<template>
  <b-card>
    <b-button v-if="!edit_handles"
              class="col-12 mb-4"
              variant="default"
              @click="edit_handles = !edit_handles">
      Bearbeiten
    </b-button>
    <b-button v-if="edit_handles"
              variant="outline-danger"
              class="col-12 mb-4"
              @click="undo_changes">
      Abbrechen
    </b-button>
    <h3>Handles / Kontakte</h3>
    <div v-for="contact in contacts"  >
    <b-row v-if="config_data[contact]" >
      <b-col >
        {{ $t('domain')[contact] }}
      </b-col>
      <b-col v-if="edit_handles">
        <v-select @search="search_handle"
                  v-model="handles[contact]"
                  label="firstname"
                  :clearable="false"
                  @input="change_handle(contact,$event), $forceUpdate()"
                  :options="handle_options">
<!--          <template slot="option" slot-scope="option" >-->
<!--            {{handle_info(option.label).firstname}}-->
<!--          </template>-->
        </v-select>
        <br>
        <div class="mb-4">
          {{handle_info(config_data[contact]).firstname }}
          {{handle_info(config_data[contact]).lastname }}
          <br>
                  <span class="small ">
                      <span v-if="handle_info(config_data[contact]).type !== 'ORG' && handle_info(config_data[contact]).organisation">
                        {{ handle_info(config_data[contact]).type !== 'ORG' ? handle_info(config_data[contact]).organisation : handle_info(config_data[contact]).firstname + ' ' + handle_info(config_data[contact]).lastname }},
                      </span>
                      {{handle_info(config_data[contact]).street }} {{handle_info(config_data[contact]).number }},
                      {{ handle_info(config_data[contact]).postcode }} {{handle_info(config_data[contact]).city }} |
                      Kontakt-ID: {{ handle_info(config_data[contact]).handle }}
                    </span>
        </div>

      </b-col>
      <b-col v-else>
        <p >
          {{handle_info(config_data[contact]).type === 'ORG' ? handle_info(config_data[contact]).organisation : handle_info(config_data[contact]).firstname + ' ' + handle_info(config_data[contact]).lastname}}
          <br>
          <span class="small">
                      <span v-if="handle_info(config_data[contact]).type !== 'ORG' && handle_info(config_data[contact]).organisation">
                        {{ handle_info(config_data[contact]).type !== 'ORG' ? handle_info(config_data[contact]).organisation : handle_info(config_data[contact]).firstname + ' ' + handle_info(config_data[contact]).lastname }},
                      </span>
                      {{handle_info(config_data[contact]).street }} {{handle_info(config_data[contact]).number }},
                      {{ handle_info(config_data[contact]).postcode }} {{handle_info(config_data[contact]).city }} |
                      Kontakt-ID: {{ handle_info(config_data[contact]).handle }}
                    </span>
        </p>

      </b-col>
    </b-row>
      <b-row v-else>
        <b-col>
          {{ $t('domain')[contact] }}
        </b-col>
        <b-col v-if="edit_handles" class="mb-4">
          <v-select @search="search_handle"
                    v-model="handles[contact]"
                    label="firstname"
                    :clearable="false"
                    placeholder="Bitte auswählen"
                    @input="change_handle(contact,$event), $forceUpdate()"
                    :options="handle_options">
          </v-select>
        </b-col>
        <b-col v-else
               class="mb-4">
          option
        </b-col>
      </b-row>
    </div>


  </b-card>

</template>

<script>
    import axios from "@/store/vue-axios"
    import Domain from "@/store/models/domain/domain"
    import DomainHandle from "@/store/models/domain/domain_handle"
    import UserConfigDefaults from "@/store/models/layout/user_config";

    export default {
        name: "luma-domain-handles-selection",
        props:{
            config:Object,
            name:String,
            setup_mode:Boolean
        },
        data: () => ({
            contacts: Domain.contacts,
            handles: {},
            edit_handles:false,
            localChange:false,
            fall_back_config:null
        }),

        computed: {

            config_data() {
                return this.handles
            },
            handle_options(){
                return DomainHandle.all().map(el=>el)
            }
        },
        methods: {

            search_handle(search,loading){
                console.log('SEARCH V :::',loading)
                return DomainHandle.fetchall(search)
            },
            undo_changes(){
                this.handles = JSON.parse(JSON.stringify(this.fall_back_config))
                this.edit_handles = false
                this.emit_local_change({},this.edit_handles)
                // const x = this.contacts.map(el=>{
                //     this.change_handle(el,this.handles[el])
                // })
            },
            emit_local_change(user_config,edit){
                this.$emit('emit_local_change',user_config,edit)
            },
            handle_info(val){
                const x = DomainHandle.find(val) ? DomainHandle.find(val) : new DomainHandle
                return x
            },
            change_handle(contact,val){
                let obj = {}
                if(this.name){
                    obj[contact]=val['handle']
                    obj['name']=this.name
                    Domain.insertOrUpdate({data:obj})
                }
                if(this.setup_mode){
                    obj[contact]=val['handle']
                    obj['$id']=this.$userConfig.$id
                    console.log('CHANGED CONTACT SETUPMODE', obj)
                    UserConfigDefaults.insertOrUpdate({data:obj})
                }
                this.localChange = true
                this.emit_local_change(obj,this.edit_handles)
                this.handles[contact] = val.handle
                console.log('CHANGED_HANDLE:::',val)
            }
        },
        created() {
          const x = Domain.contacts.map(el=>{
              this.handles[el]=this.config[el]
          })
          this.fall_back_config = JSON.parse(JSON.stringify(this.handles))
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/domain/setup_domain/luma-domain-handles-selection.vue